import { LoginCompo } from '../../Components/Login';

export function LoginPage() {
	return (
		<>
			<LoginCompo />
		</>
	);
}
